import { useTranslate } from 'react-admin'
import PageHeader from './PageHeader'

/**
 * PageHeader for a react-admin <List> screen: the resource's plural name as
 * the title, plus an optional one-line hint. The list screens were the only
 * pages with no in-page title (just the app-bar breadcrumb), so moving from
 * Clinic Team to Care Teams dropped the heading entirely.
 *
 * A component (not inline translate) so the list components stay hook-free —
 * their tests call them as plain functions to inspect the <List> props.
 */
export const ResourceListHeader = ({
  resource,
  titleKey,
  hintKey,
}: {
  resource?: string
  /** Overrides `resources.<resource>.name` (plural). */
  titleKey?: string
  hintKey?: string
}) => {
  const translate = useTranslate()
  const title = titleKey
    ? translate(titleKey)
    : translate(`resources.${resource}.name`, { smart_count: 2 })
  return <PageHeader title={title} subtitle={hintKey ? translate(hintKey) : undefined} />
}

export default ResourceListHeader
